import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {IDeadwoodRipGameData} from "./server/data/IDeadwoodRipData";
import {DeadwoodRipGameMode} from "./server/DeadwoodRipGameMode";
import {DeadwoodRipSound} from "./sound/DeadwoodRipSound";

export class DeadwoodRipPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {}

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName : "Deadwood Rip",
            hasActionSpin : true,
            mainGame : {
                header : () => "xBET",
                options : [
                    {name : "NORMAL", id : 0, image : "NORMAL.png"},
                    {name : "BOOSTED_BET", id : 1, image : "BOOSTED_BET.png"},
                    {name : "BOOSTED_BET_2", id : 1, image : "BOOSTED_BET_2.png"}
                ],
                type : ASMainGamePickOptions.BOOSTED_BET
            },
            graphics : {backgroundTextureName : "background_NORMAL"},
            getParsedData : (response:IDeadwoodRipGameData, bet:number, prevResponse:IDeadwoodRipGameData):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin : response.accumulatedRoundWin,
                    wasFeatureBuy : response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin : this.isFreeSpinTriggered(response),
                    totalSpinWinnings : +response.totalSpinWinnings,
                    isBigWin : this.isBigWin(response),
                    winType : WINTYPE.NORMAL,
                    featureName : this.getFeatureName(response),
                    isRoundComplete : this.isRoundComplete(response),
                    isBonusEnd : this.isBonusEnd(response),
                    isWinCapHit : response.brokeTheBank,
                }
                return parsedData;
            }
        };
    }

    private isFreeSpinTriggered(response:IDeadwoodRipGameData):boolean {
        return response.freespinTriggeredThisSpin === true; //(response.mode === TombstoneRipGameMode.NORMAL) && response.nextMode === TombstoneRipGameMode.FREESPIN;
    }

    private isBigWin(response:IDeadwoodRipGameData):boolean {
        let win = response.totalSpinWinnings;

        if(response.wasFeatureBuy) {
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
            let winRatio:number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio:number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response:IDeadwoodRipGameData):string {
        if((response.mode == DeadwoodRipGameMode.FREESPIN) || response.nextMode == DeadwoodRipGameMode.FREESPIN) {
            return "REDEMPTION SPINS";
        }

        if((response.mode == DeadwoodRipGameMode.FREESPIN_SUPER) || response.nextMode == DeadwoodRipGameMode.FREESPIN_SUPER) {
            return "SALVATION SPINS";
        }

        return response.mode;
    }

    private isRoundComplete(response:IDeadwoodRipGameData):boolean {
        return ([DeadwoodRipGameMode.FREESPIN, DeadwoodRipGameMode.FREESPIN_SUPER, DeadwoodRipGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:IDeadwoodRipGameData):boolean {
        return (response.nextMode === DeadwoodRipGameMode.NORMAL) && (response.mode === DeadwoodRipGameMode.FREESPIN || response.mode === DeadwoodRipGameMode.FREESPIN_SUPER);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if(trigger == ActionSpinSound.WIN) {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AS_WIN});
        } else if(trigger == ActionSpinSound.BIG_WIN) {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.AS_WIN_BIG});
        }
    }
}